var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"row-content"},[_c('div',{staticClass:"t-sm d-flex"},[_c('span',{staticClass:"t-600"},[_vm._v(_vm._s(_vm._f("pluralize")('Sponsor',_vm.sponsors.length))+":")]),_c('span',{staticClass:"ml-1 t-overflow"},[_vm._v(_vm._s(_vm._f("separateByComma")(_vm.sponsors,'name')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }